import { Link } from "react-router-dom";
import RegisterNowImg from "../../assets/register_now.png";

export default function RegisterNow({ course }) {
  return (
    <div className="w-full flex justify-center my-48 bg-red-50 py-32 rounded shadow-lg">
      <Link to={`/registration-${course}`}>
        <img
          className="w-10/12 mx-auto cursor-pointer"
          src={RegisterNowImg}
          alt="Register Now"
        />
      </Link>
    </div>
  );
}
